import { useCallback, useRef } from 'react';
import type { UseAddPanelHover } from './useAddPanelHover.types';

export const SHORT_DELAY = 100;
export const LONG_DELAY = 300;

export const useAddPanelHover = (): UseAddPanelHover => {
  const lastHoveredItemKeyRef = useRef<string>();
  const setTimeoutIdRef = useRef<number>();

  const enter = useCallback((event, callback, isLongDelay = false) => {
    lastHoveredItemKeyRef.current = undefined;
    window.clearTimeout(setTimeoutIdRef.current);

    setTimeoutIdRef.current = window.setTimeout(
      () => {
        if (!lastHoveredItemKeyRef.current && callback) {
          callback();
        }
      },
      isLongDelay ? LONG_DELAY : SHORT_DELAY,
    );
  }, []);

  const leave = useCallback((event, hoveredItemKey) => {
    lastHoveredItemKeyRef.current = hoveredItemKey;
  }, []);

  return { enter, leave };
};
